import styled from 'styled-components'

import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'

type CategoryDropdownContainerProps = {
  isMobileHeaderExpanded: boolean
}

export const CategoryDropdownContainer = styled.div<CategoryDropdownContainerProps>(
  ({ theme, isMobileHeaderExpanded }) => `
  display: ${isMobileHeaderExpanded ? 'block' : 'none'};
  flex-shrink: 0;

  & #category-dropdown-menu {
    max-height: 20rem;
    overflow-y: auto;
  }

  &  button > span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  & button > span > svg {
    flex-shrink: 0;
  }
  
  ${MEDIA_QUERIES(theme).medium} {
    display: block;
    max-width: 24.5rem;
    min-width: 20rem;

    & #category-dropdown-menu {
      max-height: 100%;
    }

    & #category-dropdown-toggle-button[aria-expanded="false"] {
      border: none;
    }

    div {
      border: none;
    }
  }
`
)
